





















import { Component, Watch } from 'vue-property-decorator';
import FormatParametersFormTypeBase from '../FormatParametersFormTypeBase/FormatParametersFormTypeBase';
import { Notification } from '../../../helpers/Notification';
import { IAssetParameterValue, AssetParameterValue } from '@models';
import AssetService from '../../../services/AssetService';

@Component
export default class FormatParametersFormSeenThisType extends FormatParametersFormTypeBase {
  name = 'format-parameters-form-seenthis-type';
  notification: Notification = new Notification();

  lblShowStatus = '';
  statusCode;
  SeenThisId = '';
  maxWeight = 120000000; //120MB
  SeenThisMaxWeightVariable = "Environment:SeenThisMaxWeight";
  assetService = AssetService;
  jsonValue: IAssetParameterValue;

  get inputPlaceholder() {
    this.lblShowStatus = '';
    if (this.value?.value && this.value?.value !== "") {
      var parsedValue = JSON.parse(this.value?.value);
       
      if (parsedValue.Id != null) {
        this.SeenThisId = parsedValue.Id;

        if (parsedValue.Status != null)
          this.lblShowStatus = 'Encoding Status: ' + parsedValue.Status;

        if (parsedValue.StatusCode != null)
          this.statusCode = parsedValue.StatusCode;
      }

    }

    return this.file?.name || this.jsonValue?.UploadedFilename || 'Default video';
  }

  get file() {
    return this.local.file;
  }

  set file(file: File) {
    if (!file || typeof (file) === 'undefined') {
      if (this.isFileSelected) {
        this.$refs['fileSelector'].lazyValue = this.file;
      }
      return;
    };
    this.handleFileSelectionChange(file);
  }

  get isFileSelected() {
    return (this.file && typeof (this.file) !== 'undefined');
  }

  handleFileSelectionChange(file) {
    _context = this;
    if(file.size > this.maxWeight){
      this.notification.Error('Maximum file size exceeded! The size of videos must be under 120 MB.');
    }
    else{
      setVideoOptions(file);
      this.update(v => {
        v.file = file;
        v.value = JSON.stringify(getJsonObject(file.name));
      });
    }
  }

  onFileSelectorClear(event) {
    this.update(v => {
      v.file = null;
      v.value = null;
    });

    this.jsonValue = null;
  }

  @Watch('value.value')
  updateJson() {
    try {
      if (this.value?.value && this.value?.value !== "") {
        this.jsonValue = JSON.parse(this.value.value);
      }
    } catch (e) {
      this.notification.Error("An error occurred while reading SeenThis parameter");
    }
  }

  getUploadStatus() {
    if ((this.local.id != '') && (this.SeenThisId != '')) {
      var response = this.assetService.updateformatparameterseenthisstatus(this.local.id, this.SeenThisId);
      response.then(r => {
        if (r.status === 200) {
          if (r.data?.value != null) {
            var returnedValue = JSON.parse(r.data?.value);
            if ((returnedValue.Id != null) && (returnedValue.StatusCode != null)) {
              this.lblShowStatus = 'Encoding Status: ' + returnedValue.Status;
              this.statusCode = returnedValue.StatusCode;
            }
            else {
              this.lblShowStatus = 'Encoding Status: Video transcoding failed. Try to re-upload the video.';
            }
          }
        }
        else {
          this.lblShowStatus = 'Could not get Status of the Video!';
          this.statusCode = null;
        }


      });
    }
  }

  created() {
    this.updateJson();

    setInterval(() => {
      if ((this.statusCode != null) && (this.statusCode < 2)) {
        this.getUploadStatus();
      }
    }, 8000)
  }
}

let _context;
let videoOptions = { height: null, width: null };
let _file;
const videoElement = document.createElement('video');
videoElement.addEventListener("loadedmetadata", function (e) {
  videoOptions = { height: null, width: null };
  videoOptions.width = videoElement.videoWidth;
  videoOptions.height = videoElement.videoHeight;
  _context.update(v => {
    v.file.videoOptions = videoOptions;
  });
}, false);

function setVideoOptions(file) {
  const reader = new FileReader();
  reader.addEventListener("load", function () {
    videoElement.src = reader.result.toString();
  }, false);
  if (file && file.size !== 0) {
    reader.readAsDataURL(file);
  }
}

function getJsonObject(uploadedFileName: string): IAssetParameterValue {
  const jsonFile = new AssetParameterValue();
  jsonFile.UploadedFilename = uploadedFileName;

  return jsonFile;
}
